import i18n from 'i18next';

export const ASSET_CONFIG: { [key: string]: any } = {};
const liveItems: Record<string, any> = {};

export function setAssetConfig(key: string, value: any) {
  ASSET_CONFIG[key] = value;
  if (key === 'ITEMS') {
    for (const [id, item] of Object.entries(liveItems)) ASSET_CONFIG.ITEMS[id] = [item.src, item.value || 0, item.price || 0];
  }
}

export function applyItemOverrides(overrides: Record<string, any> = {}) {
  ASSET_CONFIG.ITEMS = { ...(ASSET_CONFIG.ITEMS || {}) };
  ASSET_CONFIG.ITEM_NAMES = { ...(ASSET_CONFIG.ITEM_NAMES || {}) };
  for (const [id, item] of Object.entries(overrides)) {
    liveItems[id] = item;
    ASSET_CONFIG.ITEMS[id] = [item.src, item.value || 0, item.price || 0];
    if (item.name) {
      ASSET_CONFIG.ITEM_NAMES[id] = item.name;
      for (const lang of ['th', 'en', 'vi']) i18n.addResource(lang, 'translation', `item__${id}--name`, item.name);
    }
  }
}
